'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
const getScrollTop = () => window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  document.documentElement.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  document.body.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
const ScrollToTop = () => {
  const $ = _c(6);
  const [isVisible, setIsVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const toggleVisibility = () => {
        setIsVisible(getScrollTop() > 300);
      };
      window.addEventListener("scroll", toggleVisibility, {
        passive: true
      });
      document.addEventListener("scroll", toggleVisibility, {
        passive: true
      });
      return () => {
        window.removeEventListener("scroll", toggleVisibility);
        document.removeEventListener("scroll", toggleVisibility);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isVisible) {
    t2 = isVisible && <Button onClick={scrollToTop} size="icon" className="fixed right-10 bottom-10 z-50 h-12 w-12 rounded-full opacity-30 shadow-lg transition-all hover:scale-110 hover:opacity-50" aria-label="Scroll to top"><ArrowUp className="h-5 w-5" /></Button>;
    $[2] = isVisible;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <>{t2}</>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default ScrollToTop;